module.exports = __webpack_public_path__ + "static/media/metazone-logo.d2581cec.png";